/**
 * 開閉式コンテンツ
 */
export default class ToggleContent extends HTMLElement {
  constructor() {
    super();

    const accButton = this.querySelector("[aria-expanded]");
    const targetId = accButton.getAttribute("aria-controls");
    const accContent = this.querySelector(`#${targetId}`);
    const accOpenText = accButton.textContent;
    const accCloseText = accButton.dataset.toggleCloseText;

    accButton.addEventListener("click", () => {
      this.toggleOpen(accButton, accContent, accOpenText, accCloseText);
    });
  }

  toggleOpen(button, content, openText, closeText) {
    if (button.classList.contains("-is-active")) {
      button.classList.remove("-is-active");
      button.setAttribute("aria-expanded", "false");
      content.setAttribute("aria-hidden", "true");
      button.innerHTML = openText;

      content.closest("unico-toggle-content").scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      button.classList.add("-is-active");
      button.setAttribute("aria-expanded", "true");
      content.setAttribute("aria-hidden", "false");
      button.innerHTML = closeText;
    }
  }
}
